import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { Menu } from "antd";
import { getAuthorizedPages } from '../../../../redux/Settings/SettingsActions';
import navigation from "../../../../navigation/vertical";

const { SubMenu } = Menu;

export default function MenuItem(props) {
    const { onClose } = props;
    const [pages, setPages] = useState(navigation);
    const { authorizedPages } = useSelector((state) => state.settings);
    const customise = useSelector(state => state.customise)
    const location = useLocation();
    const { pathname } = location;
    const splitLocation = pathname.split("/");
    const splitLocationUrl = splitLocation[splitLocation.length - 2] + "/" + splitLocation[splitLocation.length - 1];

    useEffect(() => {
        const fetchData = async () => {
            await getAuthorizedPages({ user: localStorage.getItem('user') });
        };

        fetchData();
    }, []);

    useEffect(() => {
        let data = [];

        if (navigation) {
            navigation.map((eachPage) => {
                if (eachPage?.submenu) {
                    let childPages = [];

                    eachPage.children.map((eachChild) => {
                        if (authorizedPages.filter(y => y.screen == eachChild.navLink).length > 0) {
                            childPages.push(eachChild);
                        };
                    });

                    if (childPages.length > 0) {
                        eachPage.children = childPages;
                        data.push(eachPage);
                    };
                }
                else {
                    if (authorizedPages.filter(y => y.screen == eachPage.navLink).length > 0) {
                        data.push(eachPage);
                    };
                };
            });

            setPages(data);
        };
    }, [authorizedPages]);

    const menuItem = pages?.map((item, index) => {
        if (item.header) {
            return <Menu.ItemGroup key={index} title={item.header}></Menu.ItemGroup>;
        };

        if (item.children && item.submenu) {
            return (
                <SubMenu key={item.id} icon={item.icon} title={item.title}>
                    {item.children.map((childrens, index) => {
                        if (!childrens.children) {
                            const childrenNavLink = childrens.navLink.split("/");

                            return (<Menu.Item key={childrens.id} onClick={onClose} className={splitLocationUrl ===
                                childrenNavLink[childrenNavLink.length - 2] + "/" + childrenNavLink[childrenNavLink.length - 1]
                                ? "ant-menu-item-selected" : "ant-menu-item-selected-in-active"}>
                                <Link to={childrens.navLink}>{childrens.title}</Link>
                            </Menu.Item>);
                        }
                        else {
                            return (
                                <SubMenu key={childrens.id} title={childrens.title}>
                                    {childrens.children.map((childItem, index) => {
                                        const childrenItemLink = childItem.navLink.split("/");

                                        return (
                                            <Menu.Item key={childItem.id} onClick={onClose} className={splitLocationUrl ===
                                                childrenItemLink[childrenItemLink.length - 2] + "/" + childrenItemLink[childrenItemLink.length - 1]
                                                ? "ant-menu-item-selected" : "ant-menu-item-selected-in-active"}>
                                                <Link to={childItem.navLink}>{childItem.title}</Link>
                                            </Menu.Item>
                                        );
                                    })}
                                </SubMenu>
                            );
                        };
                    })}
                </SubMenu>
            );
        }
        else {
            const itemNavLink = item.navLink?.split("/");

            return (<Menu.Item key={item.id} icon={item.icon} onClick={onClose}
                className={splitLocation[splitLocation?.length - 2] + "/" + splitLocation[splitLocation?.length - 1] ===
                    itemNavLink[itemNavLink?.length - 2] + "/" + itemNavLink[itemNavLink?.length - 1] ? "ant-menu-item-selected" : "ant-menu-item-selected-in-active"}
            >
                <Link to={item.navLink}>{item.title}</Link>
            </Menu.Item>);
        };
    })

    return (
        <Menu mode="inline" defaultOpenKeys={[splitLocation.length === 5 ? splitLocation[splitLocation.length - 3] : null,
        splitLocation[splitLocation.length - 2]]} theme={customise.theme == "light" ? "light" : "dark"}>
            {menuItem}
        </Menu>
    );
};